"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var satcheljs_1 = require("satcheljs");
var defaultStore = {
    mruFolders: [],
    isInitialized: false,
};
exports.getStore = satcheljs_1.createStore('mruFolderCache', defaultStore);
var store = exports.getStore();
exports.default = store;
//# sourceMappingURL=store.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/mail/data/owa-mail-move-mru/lib/store/store.js
// module id = 1711
// module chunks = 23 62 105 108